// Start/Stop voting process
$(".btn-region-start").click(function (e) {
    e.preventDefault();

    let button = $(this);
    let form = button.closest('form');
    let url = form.attr("action");

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
            if (data.status == "voting-region-process-started") {
                var status_cell = button.closest('tr').find('.status-info');
                status_cell.text('Проводиться').removeClass('text-warning').removeClass('text-danger').addClass('text-success');
            }
        },
        error: function (data) {
            // Massive of errors
            let fields = [];
            for (key in data.responseJSON.errors) {
                fields.push(key);
            }
        }
    });
});

$(".btn-region-stop").click(function (e) {
    e.preventDefault();

    let button = $(this);
    let form = button.closest('form');
    let url = form.attr("action");
    
    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
            if (data.status == "voting-region-process-stopped") {
                var status_cell = button.closest('tr').find('.status-info');
                status_cell.text('Проведено').removeClass('text-success').addClass('text-danger');
            }
        },
        error: function (data) {
            // Massive of errors
            let fields = [];
            for (key in data.responseJSON.errors) {
                fields.push(key);
            }
        }
    });
});

$(".btn-all-regions-start").click(function (e) {
    e.preventDefault();
    
    let button = $(this);
    let form = button.closest('form');
    let url = form.attr("action");
    
    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
            if (data.status == "voting-all-regions-process-started") {
                $('.region-voting-process-status').text('Проводиться').removeClass('text-warning').removeClass('text-danger').addClass('text-success');
            }
        },
        error: function (data) {
            // Massive of errors
            let fields = [];
            for (key in data.responseJSON.errors) {
                fields.push(key);
            }
        }
    });
});

$(".btn-all-regions-stop").click(function (e) {
    e.preventDefault();
    
    let button = $(this);
    let form = button.closest('form');
    let url = form.attr("action");
    
    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
            if (data.status == "voting-all-regions-process-stoped") {
                $('.region-voting-process-status').text('Проведено').removeClass('text-success').addClass('text-danger');
            }
        },
        error: function (data) {
            // Massive of errors
            let fields = [];
            for (key in data.responseJSON.errors) {
                fields.push(key);
            }
        }
    });
});